var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"loading-spinner"},[_c('div',{staticClass:"spin-icon",style:(_vm.loadingColor)})])])}
var staticRenderFns = []

export { render, staticRenderFns }